import { FunctionalComponent, h } from 'preact';
import { Item } from './TocPropsTypes';

export const TocDesktopItem: FunctionalComponent<Item> = ({ href, label }) => {
	return (
		<li className="SP-TocList__item">
			<a href={href} className="SP-Link SP-Toc__link">
				<span className="SP-Link__text">
					<span className="SP-Link__title">{label}</span>
				</span>
			</a>
		</li>
	);
};
